import { clickAndDragWidth } from '@app/engine/utils/click-and-drag';
import { getEl } from '@app/engine/utils/get-el';
import { t7e } from '@app/locales/keys';
import { GroupType } from '@app/app/data/object-group';
import { StringExtractor } from '@app/app/ui/string-extractor';
import { MenuMode } from '@app/engine/core/interfaces';
import { keepTrackApi } from '@app/keepTrackApi';
import flagPng from '@public/img/icons/flag.png';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { html } from '@app/engine/utils/development/formatter';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
import { SelectSatManager } from '../select-sat-manager/select-sat-manager';
import { SoundNames } from '../sounds/sounds';
import { TopMenu } from '../top-menu/top-menu';
import { EventBus } from '@app/engine/events/event-bus';
export class CountriesMenu extends KeepTrackPlugin {
    id = 'CountriesMenu';
    dependencies_ = [TopMenu.name];
    menuMode = [MenuMode.BASIC, MenuMode.ADVANCED, MenuMode.ALL];
    bottomIconImg = flagPng;
    sideMenuElementHtml = html `
    <div id="countries-menu" class="side-menu-parent start-hidden text-select">
      <div id="country-menu" class="side-menu">
        <ul id="country-list">
        </ul>
      </div>
    </div>
    `;
    sideMenuElementName = 'countries-menu';
    addHtml() {
        super.addHtml();
        EventBus.getInstance().on(EventBusEvent.uiManagerFinal, () => {
            getEl('country-list').innerHTML = CountriesMenu.generateCountryList_();
            getEl('country-menu')
                .querySelectorAll('li')
                .forEach((element) => {
                element.addEventListener('click', () => {
                    keepTrackApi.getSoundManager()?.play(SoundNames.CLICK);
                    CountriesMenu.countryMenuClick_(element.getAttribute('data-group') ?? '');
                });
            });
            clickAndDragWidth(getEl(this.sideMenuElementName));
        });
    }
    static generateCountryList_() {
        const header = html `
    <h5 class="center-align">${t7e(`plugins.${CountriesMenu.name}.bottomIconLabel`)}</h5>
    <li class="divider"></li>
    <br/>`;
        const countryCodeList = [];
        keepTrackApi.getCatalogManager().getSats().forEach((sat) => {
            if (sat.country && !countryCodeList.includes(sat.country) && sat.country !== 'ANALSAT') {
                countryCodeList.push(sat.country);
            }
        });
        const countries = countryCodeList.map((countryCode) => {
            const country = StringExtractor.extractCountry(countryCode);
            return { country, countryCode };
        }).sort((a, b) => a.country.localeCompare(b.country));
        // Group countries by their display name
        const countryGroups = {};
        countries.forEach(({ country, countryCode }) => {
            if (countryCode === '') {
                return;
            }
            if (!countryGroups[country]) {
                countryGroups[country] = [];
            }
            countryGroups[country].push(countryCode);
        });
        // Create a single <li> per country, with all codes merged by '|'
        const mergedList = Object.entries(countryGroups).reduce((acc, [country, codes]) => {
            const dataGroup = codes.join('|');
            return `${acc}<li class="menu-selectable country-option" data-group="${dataGroup}">${country}</li>`;
        }, header);
        return `${mergedList}<br/>`;
    }
    static countryMenuClick_(countryCode) {
        const groupManagerInstance = keepTrackApi.getGroupsManager();
        if (countryCode === '') {
            throw new Error('Unknown country code');
        }
        if (!groupManagerInstance.groupList[countryCode]) {
            groupManagerInstance.createGroup(GroupType.COUNTRY, countryCode, countryCode);
        }
        CountriesMenu.groupSelected_(countryCode);
    }
    static groupSelected_(groupName) {
        const groupManagerInstance = keepTrackApi.getGroupsManager();
        const catalogManagerInstance = keepTrackApi.getCatalogManager();
        const uiManagerInstance = keepTrackApi.getUiManager();
        const searchDOM = getEl('search');
        if (typeof groupName === 'undefined') {
            return;
        }
        if (typeof groupManagerInstance.groupList[groupName] === 'undefined') {
            return;
        }
        groupManagerInstance.selectGroup(groupManagerInstance.groupList[groupName]);
        searchDOM.value = groupManagerInstance.groupList[groupName].ids.reduce((acc, id) => `${acc}${catalogManagerInstance.getSat(id)?.sccNum},`, '').slice(0, -1);
        uiManagerInstance.searchManager.fillResultBox(groupManagerInstance.groupList[groupName].ids.map((id) => ({ id })), catalogManagerInstance);
        // If a selectSat plugin exists, deselect the selected satellite
        keepTrackApi.getPlugin(SelectSatManager)?.selectSat(-1);
        // Close Menus
        if (settingsManager.isMobileModeEnabled) {
            uiManagerInstance.searchManager.closeSearch();
        }
        uiManagerInstance.hideSideMenus();
    }
}
